import DineviqLogo from './SarviqLogo';

export { DineviqLogo };
export default DineviqLogo;
